var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block"},[_c('div',{staticClass:"content-block__title"},[_vm._t("title")],2),_c('div',{staticClass:"content-block__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }